import { AdminListView } from "./AdminListView";
import { ibsAdapter } from "./ibsAdapter";

export function IBSAdminPage() {
  return <AdminListView adapter={ibsAdapter} />;
}
